import format from 'date-fns/format'

import { isHatchDisabledForServiceType } from '@providers/booking/helper'
import { TBookingContext, TBookingContextDef } from '@providers/booking/types'
import type { TPet, TShowOffersResultsPetGroup } from '@shared/booking_groups.d'
import { requiresWeightForSpecie } from '@shared/service_types'

export const buildPetGroup = (ctx: TBookingContext): TShowOffersResultsPetGroup[] => {
  const group = ctx.cart.groups[ctx.currentGroup]
  const wfs = requiresWeightForSpecie(ctx.config?.booking)
  const rc = [] as TShowOffersResultsPetGroup[]

  rc.push({
    locationSpecies: group.specieId,
    petCount: group.pets.length,
    pets: group.pets.map(
      ({ id, name, breedId, weight }) =>
        ({
          locationPetProfileId: id,
          displayName: name,
          breedId,
          weight: wfs[group.specieId] ? parseInt(weight) : undefined,
        }) as TPet
    ),
    parentOffer: group.offerSelected?.offer?.id,
  })
  return rc
}

export const buildSearchParams = (bookingCtx: TBookingContextDef) => {
  return {
    startDate: format(bookingCtx.state.startDate || 0, 'yyyy-MM-dd'),
    endDate: format(bookingCtx.state.endDate || 0, 'yyyy-MM-dd'),
    petGroups: buildPetGroup(bookingCtx.state),
    disableHatch: isHatchDisabledForServiceType(bookingCtx.state),
  }
}
